export const SOURCE_OF_FUNDS_OPTIONS = [
  { value: "salary_wages", label: "Salary/wages" },
  { value: "business_revenue", label: "Business revenue" },
  { value: "investment", label: "Investment" },
  { value: "sales_of_assets", label: "Sales of assets" },
  { value: "loan_credit_line", label: "Loan / Credit line" },
  { value: "other_sources", label: "Other sources" },
];

export const SOURCE_OF_FUNDS_DOC_TYPE_OPTIONS_BY_SOURCE = {
  salary_wages: [
    { value: "payslip", label: "Payslip" },
    { value: "tax_returns", label: "Tax returns" },
    { value: "employment_contract", label: "Employment contract" },
    { value: "bank_statement", label: "Bank statement" },
  ],
  business_revenue: [
    { value: "invoice", label: "Invoice" },
    { value: "signed_contract", label: "Signed contract" },
    { value: "bank_statement", label: "Bank statement" },
  ],
  investment: [
    { value: "investment_agreement", label: "Investment agreement" },
    { value: "grant_letter", label: "Grant letter" },
    { value: "bank_transfer_receipt", label: "Bank transfer receipt" },
  ],
  sales_of_assets: [
    { value: "sale_agreement", label: "Sale agreement" },
    { value: "title_transfer_documents", label: "Title transfer documents" },
    { value: "bank_statement", label: "Bank statement" },
  ],
  loan_credit_line: [
    { value: "loan_agreement", label: "Loan agreement" },
    { value: "proof_of_disbursement", label: "Proof of disbursement" },
    { value: "lender_details", label: "Lender details" },
  ],
  other_sources: [
    { value: "bank_statement", label: "Bank statement" },
    { value: "supporting_document", label: "Supporting document" },
    { value: "other", label: "Other" },
  ],
};

export const CURRENCY_OPTIONS = [
  { value: "NGN", label: "NGN" },
  { value: "USD", label: "USD" },
  { value: "EUR", label: "EUR" },
  { value: "GBP", label: "GBP" },
];

export const emptyFileState = {
  file: null,
  loading: false,
  uploaded: false,
  progress: 0,
};
